var map = {
	"./TreeView.vue": [
		1289,
		1292
	],
	"./affiliate.vue": [
		4367,
		5634,
		1413
	],
	"./buy-product.vue": [
		3906,
		5634,
		3914
	],
	"./collateral.vue": [
		8395,
		6878
	],
	"./customerPayinPayout.vue": [
		8746,
		8942
	],
	"./daily-bill.vue": [
		2851,
		2807
	],
	"./digital-contract.vue": [
		8742,
		9076
	],
	"./dormantUser.vue": [
		327,
		5634,
		8065
	],
	"./dpHoldings.vue": [
		8775,
		3656
	],
	"./esignFailed.vue": [
		7300,
		5708
	],
	"./esignSuccess.vue": [
		7192,
		9548
	],
	"./feedback.vue": [
		6386,
		3728
	],
	"./feedbackConfirmation.vue": [
		8536,
		337
	],
	"./freeSubscription.vue": [
		4926,
		5544
	],
	"./fund-reallocation.vue": [
		2102,
		6283
	],
	"./historyOfPayinPayout.vue": [
		8225,
		5800,
		4693
	],
	"./holdingInsight.vue": [
		6661,
		7776,
		5366
	],
	"./holdings.vue": [
		8810,
		917
	],
	"./incomeCategory.vue": [
		8677,
		6494
	],
	"./journal.vue": [
		9614,
		4002,
		7823
	],
	"./ledger.vue": [
		2369,
		2087
	],
	"./margin-client.vue": [
		81,
		2551
	],
	"./mutualFundPnL.vue": [
		383,
		34
	],
	"./mydetails.vue": [
		6259,
		2731,
		5093,
		909
	],
	"./notebook.vue": [
		4002,
		1467
	],
	"./open-position.vue": [
		7340,
		1062
	],
	"./otsConfirmation.vue": [
		8760,
		561
	],
	"./payConfirmation.vue": [
		1219,
		4935
	],
	"./payIn.vue": [
		8457,
		4046
	],
	"./payOut.vue": [
		5881,
		7825
	],
	"./payOutConfirmation.vue": [
		6745,
		9899
	],
	"./payment-fail-response.vue": [
		3875,
		1265
	],
	"./payment-history.vue": [
		8733,
		4690
	],
	"./payment-success-response.vue": [
		3138,
		7185
	],
	"./pnlCalendar.vue": [
		619,
		1731
	],
	"./profit&Loss.vue": [
		2671,
		7776,
		2105
	],
	"./realized-P&L.vue": [
		8649,
		4812
	],
	"./referral-home.vue": [
		6469,
		5767
	],
	"./request.vue": [
		4710,
		6294
	],
	"./security.vue": [
		4101,
		4941
	],
	"./segment-allocation.vue": [
		6235,
		4877
	],
	"./sso-logout.vue": [
		7768,
		7341
	],
	"./statistics&Networth.vue": [
		9840,
		2491
	],
	"./subscriptions.vue": [
		9857,
		3035
	],
	"./tax-P&L.vue": [
		8211,
		5800,
		5351
	],
	"./trade-register-FNO.vue": [
		4430,
		1378
	],
	"./trade-register.vue": [
		4344,
		9409
	],
	"./treeViewForVerifiedJournal.vue": [
		6867,
		9635
	],
	"./unrealized-P&L.vue": [
		6801,
		3298
	],
	"./verifiedJournal.vue": [
		8969,
		204
	],
	"./wallet.vue": [
		6217,
		4251
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5271;
module.exports = webpackAsyncContext;